import React, { useState, useRef } from 'react'
import { UserCircleIcon, ArrowRightIcon } from '@heroicons/react/24/solid'
// import Link from 'next/link'
// import { useRouter } from 'next/navigation';
import { Link } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../../services/axios";
import { toggleToaster, selectToasterData, selectToasterStatus, toggleLoginChange, selectLoginChange } from '../../../provider/features/helperSlice';
import { login, logout, selectUser } from '../../../provider/features/userSlice';

import { useSelector, useDispatch } from 'react-redux';

function SearchInput() {
    const [pending, setPending] = useState(false);
    const [optionalEmailNeeded, setOptionalEmailNeeded] = useState(false);
    const [isLogin, setIsLogin] = useState(true);

    const applicantIdRef = useRef(null);
    let navigate = useNavigate();


    const dispatch = useDispatch();
    const [formValue, setFormValue] = useState(
        {
            applicant_id: '',
            optional_email: '',

        }
    );
    let loginErrors = "";
    const handleChange = (event: any) => {
        setFormValue({
            ...formValue,
            [event.target.name]: event.target.value
        });
    }
    const findApplicant = async (e: any) => {
        // alert('am here');
        e.preventDefault();
        console.log(formValue);
        let applicant_id = formValue.applicant_id;
        if (applicant_id == "") {
            alert("some fields are empty");
        } else {


            // try {

            setPending(true);
            const response = await axiosInstance.get('getApplicant/' + formValue.applicant_id)
            console.log(response)


            const userData = response?.data?.data;
            console.log("main data");
            console.log(userData);
            if (response?.data?.status == "success") {
                // alert('there is data');
                dispatch(login(userData));
                dispatch(toggleToaster({ isOpen: true, toasterData: { type: "success", msg: response?.data?.message } }))
                localStorage.setItem('is_login', 'no');
                localStorage.setItem('currentUser', JSON.stringify(userData));
                // redirect('/welcome_auth');
                // router.push('/welcome_auth');
                navigate("/welcome_auth", { replace: true });

            }else if (response?.data?.status == "partial_success") {
                setOptionalEmailNeeded(true);
               dispatch(logout());
                dispatch(toggleToaster({ isOpen: true, toasterData: { type: "error", msg: "Applicant Found But Email Not Able To Receive OTP" } }))
            } else {
                dispatch(logout());
                dispatch(toggleToaster({ isOpen: true, toasterData: { type: "error", msg: "Applicant Not found" } }))
            }
            setPending(false);


        }


    }
    const findApplicantByPost = async (e: any) => {
        // alert('am here');
        e.preventDefault();
        console.log(formValue);
        let applicant_id = formValue.applicant_id;
        let optional_email = formValue.optional_email;
        if (applicant_id == "" || optional_email == "") {
            alert("some fields are empty");
        } else {


            // try {

            setPending(true);
            const response = await axiosInstance.post('getApplicantByPost',
            JSON.stringify({ applicant_id: formValue.applicant_id, optional_email:formValue.optional_email}),
            {
                headers: {
                'Content-Type': 'application/json',
                //   'Access-Control-Allow-Origin':'*'
                //   "Authorization": `Bearer ${localStorage.getItem('access')}`
                },
                //   withCredentials: true
            }
            );
            console.log(response)
            const userData = response?.data?.data;
            console.log("main data");
            console.log(userData);
            if (response?.data?.status == "success") {
                // alert('there is data');
                dispatch(login(userData));
                dispatch(toggleToaster({ isOpen: true, toasterData: { type: "success", msg: response?.data?.message } }))
                localStorage.setItem('is_login', 'no');
                localStorage.setItem('currentUser', JSON.stringify(userData));
                // redirect('/welcome_auth');
                // router.push('/welcome_auth');
                navigate("/welcome_auth", { replace: true });

            }else if (response?.data?.status == "partial_success") {
                setOptionalEmailNeeded(true);
               dispatch(logout());
                dispatch(toggleToaster({ isOpen: true, toasterData: { type: "error", msg: "Applicant Found But Email Not Able To Receive Otp" } }))
            } else {
                dispatch(logout());
                dispatch(toggleToaster({ isOpen: true, toasterData: { type: "error", msg: "Applicant Not found" } }))
            }
            setPending(false);


        }


    }
    return (
        <div className="mt-5 ">
            <h2 className='text-center text-[16px] text-gray-600 mb-3'>
                Search For Your Application
            </h2>
            <hr/>
            {/* <form action="">
                <div className='flex justify-center mx-4'>
                    <div className='flex bg-gray-100 p-1  pl-4 pr-0 gap-1
            rounded-full '>
                        <div className='flex items-center'>
                            <UserCircleIcon className="h-5 w-5 text-black" />
                            <input type="number" onChange={handleChange} id="applicant_id" name="applicant_id" placeholder='Applicant ID'
                                className='p-2 outline-none bg-gray-100 text-black placeholder:text-gray-800' />
                        </div>
                        <div className='p-0'>
                            <button className='banner_button rounded-full bg-gray-100 flex items-center' onClick={findApplicant}>
                                <span className='text-black'>Continue</span>
                                <ArrowRightIcon className="h-5 w-5 text-black ml-2" />
                            </button>
                        </div>

                    </div>
                </div>
            </form> */}
            <div className='px-5 mt-5' >
                <div className="relative w-full mb-3 items-start justify-start">
                    <label
                        className="block uppercase  text-xs font-bold mb-4" style={{ textAlign: "left",color:"#000"}}
                        htmlFor="grid-password"
                    >
                        Applicant ID
                    </label>
                    <input
                        type="number"
                        className="border-1 px-3 py-3 placeholder-blueGray-300 text-gray-600 bg-white rounded text-sm  focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        placeholder="Enter Applicant Id"
                        onChange={handleChange} id="applicant_id" name="applicant_id"
                        style={{ border: "1px solid #923d41" }}
                    />
                </div>  
                {optionalEmailNeeded ? (<>
                    <div className='text-center text-[16px] mb-3 text-red-800'>Your Application Email Was Not Able To Receive Otp</div>
                    <div className="relative w-full mb-3 items-start justify-start">
                    <label
                        className="block uppercase  text-xs font-bold mb-4" style={{ textAlign: "left",color:"#000"}}
                        htmlFor="grid-password"
                    >
                        Provide Optional Email For Otp
                    </label>
                    <input
                        type="email"
                        className="border-1 px-3 py-3 placeholder-blueGray-300 text-gray-600 bg-white rounded text-sm  focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        placeholder="Enter Optional Email To Receive Otp"
                        onChange={handleChange} id="optional_email" name="optional_email"
                        style={{ border: "1px solid #923d41" }}
                    />
                </div> 
                </>) : <> </>}
                 

                <div className="text-center mt-0">
                    {optionalEmailNeeded ? (<>
                    <button
                        /* <Link
                        to="/deployment/map_view" */
                        className="bg-[#923d41] hover:bg-[#883e43] text-white active:bg-blueGray-600 text-sm font-bold uppercase px-6 py-3 rounded-md shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 w-full ease-linear transition-all duration-150"
                        type="button"
                    // onClick={signIn}
                    onClick={findApplicantByPost}
                    >
                        Continue
                        {/* <ArrowRightIcon className="h-5 w-5 text-black ml-2" /> */}
                        {/* </Link> */}
                    </button>
                     </>) : <>
                     <button
                        /* <Link
                        to="/deployment/map_view" */
                        className="bg-[#923d41] hover:bg-[#883e43] text-white active:bg-blueGray-600 text-sm font-bold uppercase px-6 py-3 rounded-md shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 w-full ease-linear transition-all duration-150"
                        type="button"
                    // onClick={signIn}
                    onClick={findApplicant}
                    >
                        Continue
                        {/* <ArrowRightIcon className="h-5 w-5 text-black ml-2" /> */}
                        {/* </Link> */}
                    </button>
                      </>}

                </div>
            </div>
            <div className='flex items-center justify-center pt-4'>
                {pending ? (
                    <svg width="20" height="20" fill="currentColor" className="mr-2 animate-spin" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg">
                        <path d="M526 1394q0 53-37.5 90.5t-90.5 37.5q-52 0-90-38t-38-90q0-53 37.5-90.5t90.5-37.5 90.5 37.5 37.5 90.5zm498 206q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zm-704-704q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zm1202 498q0 52-38 90t-90 38q-53 0-90.5-37.5t-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zm-964-996q0 66-47 113t-113 47-113-47-47-113 47-113 113-47 113 47 47 113zm1170 498q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zm-640-704q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zm530 206q0 93-66 158.5t-158 65.5q-93 0-158.5-65.5t-65.5-158.5q0-92 65.5-158t158.5-66q92 0 158 66t66 158z">
                        </path>
                    </svg>
                ) : <> </>}
            </div>

            <br />
            <h2 className='text-center text-[16px] text-[#923d41] mb-6 mt-4'>
                Already Have OTP ? <Link to="/welcome_auth" className=' underline'>Enter Code</Link>
            </h2>
        </div>
    )
}

export default SearchInput